import { createSlice } from "@reduxjs/toolkit";
import { LP, LPSkillExpert } from "../learningPath";

const INIT_STATE: {
  data: LP;
  skillExpertsData: [LPSkillExpert];
  learnerCount: number;
  lpSkillsData: any;
  preview: boolean;
  action: boolean;
} = {
  data: {} as LP,
  skillExpertsData: [{} as LPSkillExpert] as [LPSkillExpert],
  learnerCount: 0,
  lpSkillsData: [] as any,
  preview: false,
  action: true
};

const LearningPathSlice = createSlice({
  name: "LearningPathSlice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setSkillExpertsData(state, action) {
      state.skillExpertsData = action.payload;
    },
    setLearnerCount(state, action) {
      state.learnerCount = action.payload;
    },
    setLearningPathSkillsData(state, action) {
      state.lpSkillsData = action.payload;
    },
    setPreview(state, action) {
      state.preview = action.payload;
    },
    setAction(state, action) {
      state.action = action.payload;
    },
    setResetState() {
      return INIT_STATE;
    }
  }
});

export default LearningPathSlice;

export const LearningPathSliceActions = LearningPathSlice.actions;
